import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ModalName } from "src/app/enums/modal-name";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-missing-subscription-error-modal",
  templateUrl: "./missing-subscription-error-modal.component.html",
  styleUrls: ["./missing-subscription-error-modal.component.scss"],
})
export class MissingSubscriptionErrorModalComponent {
  @Input() modalName: ModalName = ModalName.MissingSubscriptionError;
  @Input() title = "Choose new fax number";
  @Input() text = "You don't have a fax phone number yet.\nPlease choose one to start sending faxes.";
  @Input() buttonText = "Choose number";

  @Output() close = new EventEmitter();
  @Output() chooseNumber = new EventEmitter();

  constructor(private readonly _modalService: ModalService) {}

  get isOpen() {
    return this._modalService.openedModalName === this.modalName;
  }

  onClose() {
    this._modalService.closeModal();
    this.close.emit();
  }

  onChooseNumber() {
    this._modalService.closeModal();
    this.chooseNumber.emit();
  }
}
